import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { Source } from '@helpers/types/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImportRatesService } from '../import-rates.service';
import { FormControl } from '@angular/forms';
import { SourcesService } from '../../sources/sources.service';

@Component({
	selector: 'app-delete-rates-dialog',
	templateUrl: './delete-rates-dialog.component.html',
	styleUrl: './delete-rates-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DeleteRatesDialogComponent implements OnInit {

	private readonly destroyRef = inject(DestroyRef);

	readonly source = new FormControl('');
	sources: Source[] = [];
	readonly sourcesFilter = new FormControl();

	constructor(
		public readonly dataService: ImportRatesService,
		private readonly dialogRef: DialogRef<boolean>,
		public readonly rates: ImportRatesService,
		public sourcesService: SourcesService
	) {
	}

	ngOnInit(): void {
		this.sourcesService.list$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((list) => {
				if (list.length > 0) {
					this.sources = list;
				}
			});
		this.sourcesFilter.valueChanges
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((value) => {
				this.sources = this.sourcesService.list.filter((source) => {
					return source.Name.includes(value ?? '');
				});
			});
	}

	confirm(): void {
		if (this.source.value) {
			this.rates.delete({provider: this.source.value})
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe({
					next: () => this.dialogRef.close(true)
				});
		} else {
			return;
		}
	}

	close(): void {
		this.dialogRef.close(false);
	}
}
